import './styles/arthmateOffers.scss';
import { Header } from '../../comps/Header';
import { BiRupee } from "react-icons/bi";
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { env, showWrapper, hideWrapper } from '../../../../environment/environment';
import routes from '../../../../../layout/Routes';
import BottomPopOverModal from '../../../utility/ecoomercepopup';
// import { loadScript } from '../../utils/loadScript';

const ArthmateOffers = () => {
    const navigate = useNavigate();
    const [popUpMsg, setPopUpMsg] = useState('')

    const [showPopOver, setShowPopOver] = useState(false);
    const [loanAmt, setLoanAmount] = useState('0');
    const [loanPurpose, setLoanPurpose] = useState('');
    const [doctorId, setDoctorId] = useState('');
    const [dataFoRpopup, setSelectedOffer] = useState('');

    const [selected, setSelected] = useState({
        cardName: "card-1",
        productId: "",
        tenure: ""
    });
    const [offers, setOffers] = useState([]);
    const [offerCards, setOfferCards] = useState([]);
    const [renderAllProducts, setRenderAllProducts] = useState(false);
    const [apiError, setApiError] = useState(false);
    const [scriptLoaded, setscriptLoaded] = useState(false);

    const ref = useRef(0);

    const userId = localStorage.getItem('ecomuserid');
    const appointmentId = localStorage.getItem('appointmentId');
    const [errorMsg, setErrorMsg] = useState("An error has occured, please try again.");

    useEffect(() => {
        ref.current = document.getElementById('animation-wrapper');
        axios.get(`${env.api_Url}userDetails/getLoanDetailsByUserId?userId=${userId}`)
            .then(response => {
                if (response.data.message === "success") {
                    const data = response.data.data;
                    if (data) {
                        setLoanAmount(parseInt(data.loanAmount));
                        setLoanPurpose(data.loanReason);
                        setDoctorId(data.doctorId);
                    }
                }
            }).catch(console.log);
    }, []);

    useEffect(() => {
        if (!doctorId) return;
        axios.get(`${env.api_Url}getOffersAssigned?doctorId=${doctorId}`)
            .then(response => {
                if (response.data.message === "success") {
                    const offerData = response.data.data;
                    if (offerData !== "No Offers Found") {
                        const sortedOffers = offerData.sort((a, b) => a.totalEmi - b.totalEmi);
                        setOffers(sortedOffers);
                    }
                }
            }).catch(console.log);
    }, [doctorId]);

    useEffect(() => {
        if (!offers[0]) return;
        setSelected({
            cardName: "card-1",
            productId: offers[0].productId,
            tenure: offers[0].totalEmi
        });
    }, [offers]);
    const checkAndNavigate = () => {
        submitLoanData()
    }
    const gotopoup=()=>{
        const selectedOffer = offers.find(o => o.productId === selected.productId);
        setSelectedOffer(selectedOffer)
        setShowPopOver(true)
    }
    useEffect(() => {
        const minCount = Math.min(offers.length, 3);
        const tempOfferCards = renderAllProducts ? offers.map((offer, idx) => (
            <OfferCard key={idx} cardName={`card-${idx + 1}`} offerDetails={offer} loanAmount={loanAmt} selected={selected} setSelected={setSelected} />
        )) : offers.slice(0, minCount).map((offer, idx) => (
            <OfferCard key={idx} cardName={`card-${idx + 1}`} offerDetails={offer} loanAmount={loanAmt} selected={selected} setSelected={setSelected} />
        ));
        setOfferCards(tempOfferCards);
    }, [offers, selected, renderAllProducts]);
    useEffect(() => {
        const loadRazorpayScript = () => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.async = true;
            script.onload = () => setscriptLoaded(true);
            script.onerror = () => console.error("Failed to load the Razorpay script.");
            document.body.appendChild(script);
        };
        loadRazorpayScript();
    }, []);
    async function submitLoanData() {

        const submitObj = {
            userId,
            doctorId,
            loanAmount: loanAmt,
            loanReason: loanPurpose,
            loanEMI: selected.tenure,
            productId: 11111,
            internalProductId: selected.productId
        };

        if (!(submitObj.loanEMI && submitObj.productId)) {
            setErrorMsg("Please select a offer.");
            apiErrorHandler();
            return;
        }

        showWrapper(ref.current);

        try {

            const selectedOffer = offers.find(o => o.productId === selected.productId);
            setSelectedOffer(selectedOffer)
            const emi = parseFloat(loanAmt / selected.tenure);
            const advanceTenure = parseInt(selectedOffer.advanceEmi);
            const advanceAmount = emi * advanceTenure;
            if (advanceAmount != 0) {
                const orderRes = await axios.get(`${env.api_Url}razorPayCreateOrderForAppointment?appointmentId=${appointmentId}&amount=${Math.round(advanceAmount)}`);
                const checkoutResp = await axios.get(`${env.api_Url}getDataForCheckoutApiAppointment?appointmentId=${appointmentId}`);

                if (checkoutResp.data.message === "success") {
                    if (!scriptLoaded) {
                        console.error("Razorpay script not loaded yet.");
                        return;
                    }
                    const orderApiData = checkoutResp.data.data
                    const options = {
                        key: orderApiData.key,
                        amount: advanceAmount * 100,
                        currency: "INR",
                        name: "Advance EMI",
                        description: "Payment for Advance EMI",
                        order_id: orderApiData.orderId,
                        handler: () => navigate("/ecommerce/razorpay/aqvP8yxRnjBW?response=success"),
                        prefill: {
                            email: localStorage.getItem('email') || "test@example.com",
                            contact: localStorage.getItem('phone') || "9999999999"
                        },
                        theme: { color: "#3399cc" }
                    };

                    new window.Razorpay(options).open();
                }
                // } else {
                //     apiErrorHandler();
                // }
            } else {
                navigate('/ecommerce/razorpay?success')
            }
        } catch (err) {
            console.log(err);
            apiErrorHandler();
        } finally {
            hideWrapper(ref.current);
        }

    }

    function apiErrorHandler() {
        setApiError(true);
        setTimeout(() => setApiError(false), 1500);
    }

    return (
        <main className="arthmateOffers" style={{ position: 'relative' }}>
            <Header progressbarDisplay='block' canGoBack={-1} />
            <h3>Select your preferred tenure</h3>
            <p style={{ margin: "16px 0 10px 0", color: "rgba(0,0,0,0.6)" }}>Treatment amount</p>
            <p style={{ margin: "0" }}>Rs. {loanAmt.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
            <p style={{ color: "rgba(0,0,0,0.4)", marginTop: "10px" }}>Final credit amount will change according to the option you will select.</p>
            <p className="subheading">Select EMI options</p>
            {/* <div className="msgBox">
                <h4>Please note:</h4>
                <p>You will have to make payment of the advance to the clinic/doctor/hospital according to the option selected.</p>
            </div> */}
            {offerCards}
            {!renderAllProducts && <button className="submit lite" onClick={() => setRenderAllProducts(true)}>Show more options</button>}
            <p className={apiError ? "apiError" : "apiError hide"}>{errorMsg}</p>
            <button className='submit' onClick={gotopoup}>Proceed</button>
            <p style={{ textAlign: "center", margin: "1rem 0" }}>For more details and enquiries, reach out to us</p>
            <a href="tel:+918069489655">
                <button className="submit" style={{ color: "#514C9F", background: "#ECEBFF", marginTop: "0px" }}>Contact Support</button>
            </a>
            <BottomPopOverModal
            dataFoRpopup={dataFoRpopup}
                popUpMsg={popUpMsg}
                showPopOver={showPopOver}
                setShowPopOver={setShowPopOver}
                checkAndNavigate={checkAndNavigate}
                loanAmount={loanAmt}
            />
        </main>
    );
};

export default ArthmateOffers;

const OfferCard = ({ cardName, offerDetails, loanAmount, selected, setSelected }) => {

    const months = offerDetails?.totalEmi ?? "0";
    const amount = parseInt(loanAmount / months);
    const pf = offerDetails?.processingFesIncludingGSTINR
        ? "Rs. " + offerDetails.processingFesIncludingGSTINR
        : offerDetails?.processingFesIncludingGSTRate + " %";
    const interest = offerDetails?.interest ?? "0";
    const advEmi = offerDetails?.advanceEmi ?? "0";

    const cardSelector = () => setSelected({
        cardName,
        productId: offerDetails?.productId,
        tenure: months
    });
    // if(advEmi==0)return null
    return (
        <>
            {/* <div style={{background:'#4C9F68',padding:'5px'}}>✨ Recommended</div> */}

            <div className={selected.cardName === cardName ? "offerCard selected" : "offerCard"} onClick={cardSelector}>
                <div className="select">
                    <div className="selectCircle">
                        <div className="innerCirle selected"></div>
                    </div>
                </div>
                <div className='offerContentWrapper'>
                    <div className='offerContent' style={{ borderBottom: "1px solid #ccc" }}>
                        <div className="offerContentLeft">
                            <span className='offerCardSpan'>Tenure</span>
                            <span className='offerCardSpan largeText'>{months} month{months > 1 && "s"}</span>
                        </div>
                        <div className="offerContentRight">
                            <span className='offerCardSpan'>EMI amount</span>
                            <span className='offerCardSpan largeText'><BiRupee style={{ margin: "0 -6px -3px -4px" }} /> {amount.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span>
                        </div>
                    </div>
                    <div className="offerContent">
                        <div className="offerContentLeft">
                            <span className='offerCardSpan'>Processing fees</span>
                            <span className='offerCardSpan'>Interest rate</span>
                            <span className='offerCardSpan'>Advance EMI(s)</span>
                        </div>
                        <div className="offerContentRight">
                            <span className='offerCardSpan'>{pf}</span>
                            <span className='offerCardSpan'>{interest} %</span>
                            <span className='offerCardSpan'>{advEmi.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};